import { FunctionComponent } from 'react';
import styles from './DefaultTableEmptyState.module.scss';
import { TableEmptyState } from './TableEmptyState';

interface DefaultTableEmptyStateProps {
    title?: string;
    description?: Array<string>;
}

const defaultDescription = [
    `What you search was unfortunately not found or`,
    `doesn't exist, try to find something else.`
];

export const DefaultTableEmptyState: FunctionComponent<DefaultTableEmptyStateProps> = props => {
    return (
        <TableEmptyState>
            <p className={styles.title}>{props.title ?? 'Oops! No result found'}</p>
            {(props.description ?? defaultDescription).map((line, index) => (
                <p
                    key={index}
                    className={styles.descriptionLine}
                >
                    {line}
                </p>
            ))}
        </TableEmptyState>
    );
};

export default DefaultTableEmptyState;
